import ChurchPage from './churchPage.component';

export default ChurchPage;